// ZendeskWidgetController.jsx 6004224000
import React, { useEffect } from "react";
import { useGrowthBook } from "@growthbook/growthbook-react";
import DataLayerHelper from "../../../helpers/tagManager/DataLayerHelper";
 
const ZendeskWidgetController = () => {
  const growthbook = useGrowthBook();
  const isZendeskEnabled = growthbook.getFeatureValue("commercial-chatbot-data", false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      // @ts-ignore
      if (typeof window.zE !== "undefined") {
        if (isZendeskEnabled) {
          // @ts-ignore
          window.zE("messenger", "show");
          // @ts-ignore
          window.zE("messenger:on", "open", () => {
            DataLayerHelper.pushEvent('select_content', {content_type: 'commercial-chatbot-data', content_id: 'commercial-chatbot-data-open'})
          });
        } else {
          // @ts-ignore
          window.zE("messenger", "hide");
        }
        clearInterval(intervalId);
      }
    }, 500);

    return () => clearInterval(intervalId);
  }, [isZendeskEnabled]);

  return null;
};

export default ZendeskWidgetController;
